import React, { useState } from 'react';

import './MarketRisk.css';
import PageShell from '../components/layout/PageShell';

import VARBacktesting from "../components/var/VARBacktesting";

const MarketRiskVAR: React.FC = () => {
  const [activeView, setActiveView] = useState<string>('varbacktesting');

return (
     <PageShell>

      <nav className="nav-bar">
        <div
          className={`nav-item ${activeView === 'varbacktesting' ? 'active' : ''}`}
          onClick={() => setActiveView('varbacktesting')}
        >
          VAR Back Tests
        </div>
        {/*<div*/}
        {/*  className={`nav-item ${activeView === 'stress_tests' ? 'active' : ''}`}*/}
        {/*  onClick={() => setActiveView('stress_tests')}*/}
        {/*>*/}
        {/*  Coming soon*/}
        {/*</div>*/}


      </nav>
      <div className="view-stack">
      <div className={`view-pane ${activeView==='varbacktesting' ?'is-active':''}`}>
        <div className="market-risk-content-container">
          {/*<button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
          <VARBacktesting  />
        </div>
      </div>
      {/*<div className={`view-pane ${activeView==='stress_tests' ?'is-active':''}`}>*/}
      {/*  <div className="market-risk-content-container">*/}
      {/*    <button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
      {/*    <SeasonalityDashboard />*/}
      {/*  </div>*/}
      {/*</div>*/}

    </div>
     </PageShell> );
};

export default MarketRiskVAR;
